/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UltimateBeneficialOwner
 */
export interface UltimateBeneficialOwner {
    /**
     * Client First Name
     * @type {string}
     * @memberof UltimateBeneficialOwner
     */
    firstname: string;
    /**
     * Client Last Name
     * @type {string}
     * @memberof UltimateBeneficialOwner
     */
    lastname: string;
    /**
     * Client Nationality (use ISO 3166-1 alpha-3 format)
     * @type {string}
     * @memberof UltimateBeneficialOwner
     */
    nationality: string;
    /**
     * Client Birthdate
     * @type {string}
     * @memberof UltimateBeneficialOwner
     */
    dateOfBirth: string;
    /**
     * Client City of Birth
     * @type {string}
     * @memberof UltimateBeneficialOwner
     */
    cityOfBirth?: string;
    /**
     * Client Country of Birth (use ISO 3166-1 alpha-3 format)
     * @type {string}
     * @memberof UltimateBeneficialOwner
     */
    countryOfBirth?: string;
    /**
     * Country of Residence (use ISO 3166-1 alpha-3 format)
     * @type {string}
     * @memberof UltimateBeneficialOwner
     */
    countryOfResidence: string;
    /**
     * 
     * @type {number}
     * @memberof UltimateBeneficialOwner
     */
    startDate?: number;
    /**
     * 
     * @type {number}
     * @memberof UltimateBeneficialOwner
     */
    endDate?: number;
    /**
     * Ultimate Beneficial Owner ID
     * @type {number}
     * @memberof UltimateBeneficialOwner
     */
    ultimateBeneficialOwnerId?: number;
}

/**
 * Check if a given object implements the UltimateBeneficialOwner interface.
 */
export function instanceOfUltimateBeneficialOwner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "firstname" in value;
    isInstance = isInstance && "lastname" in value;
    isInstance = isInstance && "nationality" in value;
    isInstance = isInstance && "dateOfBirth" in value;
    isInstance = isInstance && "countryOfResidence" in value;

    return isInstance;
}

export function UltimateBeneficialOwnerFromJSON(json: any): UltimateBeneficialOwner {
    return UltimateBeneficialOwnerFromJSONTyped(json, false);
}

export function UltimateBeneficialOwnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): UltimateBeneficialOwner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'nationality': json['nationality'],
        'dateOfBirth': json['dateOfBirth'],
        'cityOfBirth': !exists(json, 'cityOfBirth') ? undefined : json['cityOfBirth'],
        'countryOfBirth': !exists(json, 'countryOfBirth') ? undefined : json['countryOfBirth'],
        'countryOfResidence': json['countryOfResidence'],
        'startDate': !exists(json, 'startDate') ? undefined : json['startDate'],
        'endDate': !exists(json, 'endDate') ? undefined : json['endDate'],
        'ultimateBeneficialOwnerId': !exists(json, 'ultimateBeneficialOwnerId') ? undefined : json['ultimateBeneficialOwnerId'],
    };
}

export function UltimateBeneficialOwnerToJSON(value?: UltimateBeneficialOwner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'firstname': value.firstname,
        'lastname': value.lastname,
        'nationality': value.nationality,
        'dateOfBirth': value.dateOfBirth,
        'cityOfBirth': value.cityOfBirth,
        'countryOfBirth': value.countryOfBirth,
        'countryOfResidence': value.countryOfResidence,
        'startDate': value.startDate,
        'endDate': value.endDate,
        'ultimateBeneficialOwnerId': value.ultimateBeneficialOwnerId,
    };
}

